import { z } from 'zod';

export const purposeAIGenerateSchema = z.object({
  company_name: z.string().min(1, 'Company name must be at least 1 character').optional().or(z.literal('')),
  industry: z.string().min(1, 'Industry must be at least 1 character').optional().or(z.literal('')),
  target_market: z.string().min(3, 'Target market must be at least 3 characters').optional().or(z.literal('')),
  current_activities: z
    .string()
    .min(5, 'Current activities must be at least 5 characters')
    .optional()
    .or(z.literal('')),
});

export type PurposeAIGenerateFormData = z.infer<typeof purposeAIGenerateSchema>;
